import { useQuery } from '@tanstack/react-query';
import { officeApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/**
 * @registry The office that owns a division, for the daily-module toggles and
 * daily question set the daily forms render.
 */
export function useOfficeByDivision(divisionId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.organization.officeByDivision(divisionId ?? -1),
    queryFn: ({ signal }) =>
      officeApiClient.getByDivision(divisionId!, toCancelToken(signal)),
    enabled: divisionId != null && divisionId > 0,
    staleTime: 5 * 60_000,
    meta: { errorContext: 'office by division' },
  });
}
